import React from "react";

import { Card } from "@veneer/core";
import { CourseCardImage } from "./CourseCardImage";

//CourseDto;
interface CourseCardProps {
  course: any;
  imagesLoaded: boolean;
  imageUrl?: string;
  onClick: (courseID: number, isReinforcement: boolean) => void;
  formatDate: (date: string) => string;
  t: (key: string) => string;
}

export const CourseCard: React.FC<CourseCardProps> = ({
  course,
  imagesLoaded,
  imageUrl,
  onClick,
  formatDate,
  t,
}) => {
  const hasEndDate =
    course.endDate &&
    String(course.endDate) !== "" &&
    String(course.endDate) !== "0001-01-01T00:00:00";

  return (
    <Card
      appearance="outlined"
      className="coursesCards"
      onClick={() => onClick(course.courseID, course.isReinforcement)}
      content={
        <div className="coursesContentCards">
          {course.isReinforcement && (
            <span className="reinforcementBadge">
              {t("header.reinforcementCourse")}
            </span>
          )}

          <CourseCardImage imagesLoaded={imagesLoaded} imageUrl={imageUrl} />

          <div>
            <h6>{course.courseName}</h6>
            <br />
            <p>{course.description}</p>
            <br />
            {hasEndDate ? (
              <p>
                {t("header.endsOn")}: {formatDate(String(course.endDate))}
              </p>
            ) : (
              <p>{t("header.noExpiration")}</p>
            )}
          </div>
        </div>
      }
    />
  );
};
